"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventsBackendKinesis = void 0;
const kinesis_1 = require("@deliverr/commons-aws/lib/kinesis");
const commons_logs_1 = require("@deliverr/commons-logs");
class EventsBackendKinesis extends kinesis_1.KinesisClient {
    constructor(streamUrl) {
        super(streamUrl);
        this.streamUrl = streamUrl;
        if (!streamUrl) {
            commons_logs_1.log.error("Events: Kinesis: Missing streamUrl");
        }
        this.streamName = streamUrl.split("/").pop();
        commons_logs_1.log.info({ streamName: this.streamName, streamUrl });
    }
    async submit(event) {
        try {
            commons_logs_1.log.info({ event, stream: this.streamName }, "Events: Kinesis: putRecord");
            await this.putRecord(this.streamName, event);
        }
        catch (error) {
            commons_logs_1.log.error({
                error,
                event,
                stream: this.streamName,
                streamUrl: this.streamUrl,
            }, "Events: Kinesis: putRecord failed");
            throw error;
        }
    }
}
exports.EventsBackendKinesis = EventsBackendKinesis;
//# sourceMappingURL=EventsBackendKinesis.js.map